module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_gold_ghost-b1d4f3dacfbe1551d656de3dfa5d6ae6.png";